import corporateRequest from 'utils/corporateRequest'
import authRequest from 'utils/authRequest'
import instituteRequest from 'utils/instituteRequest'
import ErrorMessage from 'utils/ErrorMessage'

export const getRoleLinks = async (jobId, params = {}) => {
  try {
    const queryParams = new URLSearchParams()
    if (params.search) queryParams.append('search', params.search)
    if (params.state) queryParams.append('state', params.state)
    if (params.city) queryParams.append('city', params.city)
    if (params.tier !== undefined && params.tier !== null && params.tier !== '')
      queryParams.append('tier', params.tier)
    if (params.hasPoc) queryParams.append('hasPoc', params.hasPoc)
    if (params.emailSent) queryParams.append('emailSent', params.emailSent)
    if (params.formStatus) queryParams.append('formStatus', params.formStatus)
    if (params.pageNo !== undefined) queryParams.append('pageNo', params.pageNo)
    if (params.pageLimit) queryParams.append('pageLimit', params.pageLimit)

    const result = await corporateRequest.get(
      `/corporates/jobs/${jobId}/role-links?${queryParams.toString()}`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const getRoleLinkFilters = async (jobId) => {
  try {
    const result = await corporateRequest.get(
      `/corporates/jobs/${jobId}/role-links/filters`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const getRoleData = async (jobId) => {
  try {
    const result = await corporateRequest.get(`/corporates/jobs/${jobId}`)
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const checkGmailAuth = async (email) => {
  try {
    const result = await authRequest.get(
      `/gmail/isAuthorized?email=${encodeURIComponent(email)}`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const startGmailAuth = async (email) => {
  try {
    const response = await authRequest.post('/gmail/auth/start', { email })
    if (!response?.data?.data?.authUrl) {
      throw new Error('No auth URL received')
    }
    const popup = window.open(
      response.data.data.authUrl,
      'authPopup',
      'width=600,height=700'
    )
    if (!popup) {
      throw new Error('Popup was blocked. Please allow popups for this site.')
    }
    return new Promise(resolve => {
      const checkPopup = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(checkPopup)
          resolve()
        }
      }, 500)
    })
  } catch (error) {
    console.error('Auth error:', error)
    throw error
  }
}

export const sendRoleEmail = async (payload) => {
  try {
    const result = await authRequest.post('/gmail/sendRoleEmail', payload)
    return result?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const createCorporateInstituteDetails = async (corporateId, payload) => {
  try {
    const result = await instituteRequest.post(
      `/corporate/${corporateId}/instituteDetails`,
      payload
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const updateCorporateInstituteDetails = async (
  corporateId,
  instituteCampusId,
  payload
) => {
  try {
    const result = await instituteRequest.put(
      `/corporate/${corporateId}/instituteDetails/${instituteCampusId}`,
      payload
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const updateRoleLinksEmailSent = async (jobId, instituteCampusIds) => {
  try {
    const result = await corporateRequest.put(
      `/corporates/jobs/${jobId}/role-links/email-sent`,
      { instituteCampusIds }
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}

export const regenerateTallyForm = async (jobId, instituteCampusId) => {
  try {
    const result = await corporateRequest.post(
      `/corporates/jobs/${jobId}/institute/${instituteCampusId}/regenerate-form`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error)
    return null
  }
}
